const IllustrationEmptySearch = () => (
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M45.1275 9.11104C45.1275 9.11104 45.6683 23.0358 67.8675 26.045C87.5825 28.7172 78.6089 52.1981 70.7501 58.9855C60.5695 67.778 43.0569 63.091 40.8446 74.4652C38.6322 85.8394 14.0348 78.4119 16.3892 61.1465C19.3179 39.6689 7.14603 44.8652 1.99419 38.4178C-1.70332 33.7906 1.85599 14.8174 15.2783 14.1851C26.5729 13.6529 26.5371 8.74051 27.8178 5.25855C29.6649 0.236756 43.0418 -2.92753 45.1275 9.11104Z"
      fill="#D8F8E9"
    />
    <mask
      id="mask0_253_27943"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M45.1275 9.11104C45.1275 9.11104 45.6683 23.0358 67.8675 26.045C87.5825 28.7172 78.6089 52.1981 70.7501 58.9855C60.5695 67.778 43.0569 63.091 40.8446 74.4652C38.6322 85.8394 14.0348 78.4119 16.3892 61.1465C19.3179 39.6689 7.14603 44.8652 1.99419 38.4178C-1.70332 33.7906 1.85599 14.8174 15.2783 14.1851C26.5729 13.6529 26.5371 8.74051 27.8178 5.25855C29.6649 0.236756 43.0418 -2.92753 45.1275 9.11104Z"
        fill="#DBE7FE"
      />
    </mask>
    <g mask="url(#mask0_253_27943)">
      <g opacity="0.9">
        <circle cx="6.88965" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="6.71606" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="16.4525" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="26.1891" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="35.9255" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="45.6621" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="55.3986" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="65.1351" r="0.5" fill="#25C279" />
        <circle cx="6.88965" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="15.5566" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="24.2227" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="32.8896" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="41.5566" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="50.2227" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="58.8896" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="67.5566" cy="74.8716" r="0.5" fill="#25C279" />
        <circle cx="76.2227" cy="74.8716" r="0.5" fill="#25C279" />
      </g>
    </g>
    <path
      d="M38.2163 58.2716C48.0347 58.2716 55.994 50.3122 55.994 40.4938C55.994 30.6754 48.0347 22.7161 38.2163 22.7161C28.3979 22.7161 20.4385 30.6754 20.4385 40.4938C20.4385 50.3122 28.3979 58.2716 38.2163 58.2716Z"
      fill="#F2FDF8"
    />
    <path
      d="M63.8953 66.1729L52.0434 54.321M55.994 40.4938C55.994 50.3122 48.0347 58.2716 38.2163 58.2716C28.3979 58.2716 20.4385 50.3122 20.4385 40.4938C20.4385 30.6754 28.3979 22.7161 38.2163 22.7161C48.0347 22.7161 55.994 30.6754 55.994 40.4938Z"
      stroke="#25C279"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask
      id="mask1_253_27943"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="20"
      y="22"
      width="36"
      height="37"
    >
      <path
        d="M38.2114 58.2715C48.0298 58.2715 55.9892 50.3121 55.9892 40.4937C55.9892 30.6753 48.0298 22.7159 38.2114 22.7159C28.393 22.7159 20.4336 30.6753 20.4336 40.4937C20.4336 50.3121 28.393 58.2715 38.2114 58.2715Z"
        fill="#EFF4FF"
      />
    </mask>
    <g mask="url(#mask1_253_27943)"></g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.2958 32.0001C32.1393 32.0001 31.0625 32.5891 30.4385 33.5628L28.8106 36.1035C27.8285 37.6362 28.2147 39.4842 29.3808 40.5717C29.3617 40.6872 29.3456 40.8054 29.3319 40.9263C29.2497 41.6558 29.2497 42.5705 29.2497 43.7049V43.7953C29.2497 44.9297 29.2497 45.8444 29.3319 46.5739C29.417 47.3282 29.5978 47.9767 30.0246 48.533C30.2242 48.793 30.4569 49.0257 30.7169 49.2252C31.2732 49.652 31.9217 49.8329 32.6759 49.9179C33.4054 50.0001 34.3201 50.0001 35.4545 50.0001H40.5449C41.6793 50.0001 42.594 50.0001 43.3235 49.9179C44.0778 49.8329 44.7263 49.652 45.2826 49.2252C45.5426 49.0257 45.7753 48.793 45.9748 48.533C46.4016 47.9767 46.5825 47.3282 46.6675 46.5739C46.7498 45.8444 46.7497 44.9297 46.7497 43.7953V43.7049C46.7497 42.5705 46.7498 41.6558 46.6675 40.9263C46.6539 40.8056 46.6378 40.6875 46.6187 40.5721C47.7852 39.4846 48.1716 37.6364 47.1893 36.1035L45.5614 33.5628C44.9375 32.5891 43.8606 32.0001 42.7042 32.0001H33.2958ZM45.2028 41.3693C44.9001 41.4542 44.5772 41.5001 44.2378 41.5001C42.9844 41.5001 41.8557 40.8353 41.2341 39.8024C40.5328 40.8164 39.3629 41.5001 37.9983 41.5001C36.6349 41.5001 35.4658 40.8176 34.7643 39.805C34.1424 40.8364 33.0145 41.5001 31.7621 41.5001C31.4226 41.5001 31.0995 41.4541 30.7967 41.3691C30.7506 41.966 30.7497 42.7242 30.7497 43.7501C30.7497 44.9403 30.7508 45.7702 30.8225 46.4059C30.8924 47.0263 31.0216 47.3682 31.2147 47.6198C31.3344 47.7758 31.474 47.9155 31.63 48.0352C31.8817 48.2282 32.2235 48.3574 32.844 48.4273C33.3237 48.4814 33.9141 48.4953 34.6865 48.4989V45.2501C34.6865 44.2836 35.47 43.5001 36.4365 43.5001H39.5625C40.529 43.5001 41.3125 44.2836 41.3125 45.2501V48.4989C42.0852 48.4953 42.6757 48.4814 43.1555 48.4273C43.776 48.3574 44.1178 48.2282 44.3694 48.0352C44.5254 47.9155 44.6651 47.7758 44.7848 47.6198C44.9779 47.3682 45.107 47.0263 45.177 46.4059C45.2486 45.7702 45.2497 44.9403 45.2497 43.7501C45.2497 42.7242 45.2489 41.9661 45.2028 41.3693ZM34.9814 33.5001H33.2958C32.6505 33.5001 32.0497 33.8287 31.7015 34.3721L30.0736 36.9127C29.2183 38.2475 30.1768 40.0001 31.7621 40.0001C32.6779 40.0001 33.4774 39.3797 33.7048 38.4926L34.1543 36.7389C34.1649 36.6898 34.1765 36.6407 34.1891 36.5915L34.9814 33.5001ZM35.6153 37.0799L36.5328 33.5001H39.4667L40.3545 36.9639C40.7488 38.5025 39.5866 40.0001 37.9983 40.0001C36.4499 40.0001 35.3065 38.5769 35.6153 37.0799ZM41.0156 33.5001L42.2952 38.4926C42.5225 39.3797 43.322 40.0001 44.2378 40.0001C45.8231 40.0001 46.7816 38.2475 45.9264 36.9127L44.2984 34.3721C43.9503 33.8287 43.3494 33.5001 42.7042 33.5001H41.0156ZM39.8125 45.2501V48.5001H36.1865V45.2501C36.1865 45.1121 36.2985 45.0001 36.4365 45.0001H39.5625C39.7006 45.0001 39.8125 45.1121 39.8125 45.2501Z"
      fill="#25C279"
    />
  </svg>
);

export default IllustrationEmptySearch;
